/* Presentation only. Existing adapters own prices, dates and quote validity. */
(function () {
  'use strict';
  var theme = window.Shopify && window.Shopify.theme;
  var allowedTheme = theme && ((theme.role === 'unpublished' && ['186928333178', '187352842618'].indexOf(String(theme.id)) !== -1) || (theme.role === 'main' && String(theme.id) === '187352842618'));
  if (!allowedTheme || window.dsrcvCartDeliveryDisclosure) return;
  var open = false, queued = false, sequence = 0, escapeHandled = false, recommendations = new WeakSet();
  var bfRecommendation = null;
  var sourceNode = null, sourceKey = '', sourceText = '';
  function text(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
  function cartKey(drawer) {
    return [window.Shopify.country, window.Shopify.currency && window.Shopify.currency.active].join(':') + '|' + Array.prototype.map.call(drawer.querySelectorAll('[data-native-ucd-line-quantity]'), function (input) {
      var item = input.closest('.NativeUcdCartItem');
      return input.getAttribute('data-line-id') + ':' + input.value + ':' + (item && item.getAttribute('data-native-ucd-line-properties') || '');
    }).sort().join('|');
  }
  function element(tag, className, attribute) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (attribute) node.setAttribute(attribute, '');
    return node;
  }
  function rows(container, values) {
    var signature = JSON.stringify(values);
    if (container.getAttribute('data-content') === signature) return;
    var restoreFocus = container.contains(document.activeElement);
    container.textContent = '';
    values.forEach(function (value) {
      var row = element('div', 'CartShipmentDetails__Row');
      var label = element('span', 'CartShipmentDetails__Label'), detail = document.createElement('span');
      label.textContent = value[0]; detail.textContent = value[1];
      if (value[3] === 'dispatch-info') {
        var information = element('details', 'CartArrivalDetails', 'data-cart-arrival-information');
        var summary = document.createElement('summary'), note = document.createElement('p');
        var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 20 20'); icon.setAttribute('aria-hidden', 'true'); icon.setAttribute('focusable', 'false');
        icon.innerHTML = '<circle cx="10" cy="10" r="7"/><path d="M10 9v5"/><circle cx="10" cy="6.5" r=".7" fill="currentColor" stroke="none"/>';
        summary.setAttribute('aria-label', value[0] + '. Delivery information');
        summary.append(label, icon);
        note.textContent = 'During Black Friday, despatch may take up to 2 working days. This allowance is already included in your estimated delivery dates. Your order may arrive sooner.';
        information.append(summary, note); row.appendChild(information);
      } else row.appendChild(label);
      if (value[2] === 'arrival') row.classList.add('CartShipmentDetails__Row--arrival');
      else row.appendChild(detail);
      container.appendChild(row);
    });
    container.setAttribute('data-content', signature);
    if (restoreFocus) {
      var target = container.querySelector('[data-cart-arrival-information] > summary') || container.closest('#sidebar-cart').querySelector('[name="checkout"]');
      if (target) target.focus();
    }
  }
  function itemName(item) {
    var title = item.querySelector('.NativeUcdCartItem__Title');
    var size = item.querySelector('[data-native-ucd-line-variant]');
    var option = size && size.options[size.selectedIndex];
    return (text(title && title.textContent) || 'Pre-order item') + (option ? ' · ' + text(option.textContent) : '');
  }
  function shortDates(values) {
    if (values.length === 1) return values[0];
    var parsed = values.map(function (value) { return value.match(/^(\d{1,2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4})$/); });
    if (parsed.length && parsed.every(Boolean)) {
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      parsed.sort(function (a, b) { return Number(a[3]) - Number(b[3]) || months.indexOf(a[2]) - months.indexOf(b[2]) || Number(a[1]) - Number(b[1]); });
      var first = parsed[0], last = parsed[parsed.length - 1];
      if (parsed.length === 2 && first[2] === last[2] && first[3] === last[3]) return first[1] + ' & ' + last[1] + ' ' + last[2] + ' ' + last[3];
      return first[1] + ' ' + first[2] + (first[3] === last[3] ? '' : ' ' + first[3]) + ' – ' + last[1] + ' ' + last[2] + ' ' + last[3];
    }
    return values.join(' / ');
  }
  function compactBenefits(drawer, summary) {
    if (String(theme.id) === '187352842618') {
      var recommendation = drawer.querySelector('[data-native-ucd-recommendations-disclosure]');
      if (recommendation && recommendation !== bfRecommendation) {
        if (bfRecommendation) recommendation.open = bfRecommendation.open;
        bfRecommendation = recommendation;
      }
      var benefits = drawer.querySelector('.NativeUcdDrawer__Messages--compact');
      if (benefits) {
        if (benefits.hidden) benefits.hidden = false;
        var delivery = benefits.querySelector('.NativeUcdDrawer__BenefitValue');
        var progress = drawer.querySelector('[data-cart-delivery-progress]');
        if (delivery && progress && !delivery.contains(progress)) delivery.appendChild(progress);
      }
      var oldProgress = summary.querySelector('[data-cart-shipment-progress]');
      if (oldProgress) oldProgress.remove();
      return;
    }
    var footer = drawer.querySelector('.NativeUcdDrawer__Footer');
    var benefits = drawer.querySelector('.NativeUcdDrawer__Messages--compact');
    if (benefits && footer) {
      var message = benefits.querySelector('[data-native-ucd-return-message]');
      if (String(theme.id) !== '187352842618' && message && !drawer.querySelector('[data-cart-returns-disclosure]')) {
        var returns = element('details', 'CartReturnsDetails', 'data-cart-returns-disclosure');
        var heading = document.createElement('summary'), link = document.createElement('a');
        heading.textContent = 'Returns & exchanges'; link.href = '/a/return'; link.textContent = 'View returns options';
        returns.append(heading, message, link); footer.appendChild(returns);
      }
      if (!benefits.hidden) benefits.hidden = true;
    }
    var progress = drawer.querySelector('[data-cart-delivery-progress]');
    var progressHome = summary.querySelector('[data-cart-shipment-progress]');
    if (!progressHome) { progressHome = element('p', 'CartShipmentProgress', 'data-cart-shipment-progress'); summary.appendChild(progressHome); }
    if (!progress) { progress = element('span', '', 'data-cart-delivery-progress'); progressHome.appendChild(progress); }
    else if (progress.parentNode !== progressHome) progressHome.appendChild(progress);
    var visible = /^Add .+ for free delivery$/.test(text(progress.textContent));
    if (progressHome.hidden === visible) progressHome.hidden = !visible;
    var recommendation = drawer.querySelector('[data-native-ucd-recommendations-disclosure]');
    if (recommendation && !recommendations.has(recommendation)) { recommendations.add(recommendation); recommendation.open = false; }
  }
  function render() {
    queued = false;
    var drawer = document.getElementById('sidebar-cart');
    var label = drawer && drawer.querySelector('[data-native-ucd-shipping-label]');
    var source = drawer && drawer.querySelector('[data-cart-delivery-estimate]');
    var summary = label && label.closest('.NativeUcdDrawer__DeliverySummary');
    if (!summary) { open = false; return; }
    var preorder = drawer.getAttribute('data-native-ucd-has-pre-order') === 'true';
    var stock = drawer.getAttribute('data-native-ucd-has-non-pre-order') === 'true';
    var button = summary.querySelector('[data-cart-shipment-toggle]');
    if (!preorder && !stock) {
      if (button) {
        if (summary.contains(document.activeElement)) { var checkout = drawer.querySelector('[name="checkout"]'); if (checkout) checkout.focus(); }
        summary.querySelector('[data-cart-shipment-headline]').remove(); summary.querySelector('[data-cart-shipment-panel]').remove(); button.remove();
        summary.removeAttribute('data-cart-shipment-disclosure');
      }
      open = false; return;
    }
    var key = cartKey(drawer), value = text(source && source.textContent);
    if (source !== sourceNode || value !== sourceText) { sourceNode = source; sourceText = value; sourceKey = key; }
    if (!button) {
      var headline = element('div', 'CartShipmentHeadline', 'data-cart-shipment-headline');
      button = element('button', 'CartShipmentToggle', 'data-cart-shipment-toggle');
      button.type = 'button'; button.appendChild(document.createTextNode('Delivery details'));
      var chevron = element('span', 'CartShipmentToggle__Chevron'); chevron.setAttribute('aria-hidden', 'true'); button.appendChild(chevron);
      var panel = element('div', 'CartShipmentDetails', 'data-cart-shipment-panel');
      panel.id = 'CartShipmentDetails-' + (++sequence); button.setAttribute('aria-controls', panel.id);
      panel.append(element('div', '', 'data-cart-shipment-rows'), element('div', 'CartShipmentDetails__Notes', 'data-cart-shipment-notes'));
      summary.querySelector('[data-native-ucd-shipping-row]').insertAdjacentElement('afterend', headline);
      headline.insertAdjacentElement('afterend', button); button.insertAdjacentElement('afterend', panel);
      summary.setAttribute('data-cart-shipment-disclosure', '');
    }
    var panel = summary.querySelector('[data-cart-shipment-panel]');
    var preorderDetails = String(theme.id) !== '187352842618' || preorder;
    if (!preorderDetails) {
      if (button === document.activeElement || panel.contains(document.activeElement)) {
        var checkout = drawer.querySelector('[name="checkout"]'); if (checkout) checkout.focus();
      }
      open = false;
    }
    if (button.hidden === preorderDetails) button.hidden = !preorderDetails;
    button.setAttribute('aria-expanded', String(open)); if (panel.hidden === open) panel.hidden = !open;
    var country = String(window.Shopify.country || '').toUpperCase();
    var shipping = window.dsrcvCartShipping && window.dsrcvCartShipping.getState();
    var totals = drawer.querySelector('[data-native-ucd-merchandise-total]');
    var subtotal = totals && Number(totals.getAttribute('data-native-ucd-merchandise-total'));
    var rate = shipping && shipping.rate;
    var contextCurrent = source && sourceKey === key && shipping && shipping.status === 'available' && rate &&
      rate.countryCode === country && rate.currency === (window.Shopify.currency && window.Shopify.currency.active) &&
      Number.isSafeInteger(subtotal) && subtotal >= 0 && rate.subtotalCents === subtotal;
    var verified = contextCurrent && typeof window.dsrcvGetCartDeliveryEstimate === 'function' ? text(window.dsrcvGetCartDeliveryEstimate(country, subtotal, rate)) : '';
    var estimate = verified || (contextCurrent && !source.hidden ? value : '');
    estimate = estimate.replace(/\s*·\s*(?:pre-orders on listed dates|despatched together when all items are ready)$/i, '').replace(/^In-stock:\s*/i, '');
    if (/^(?:Checking |Delivery estimate at checkout|In-stock delivery estimate at checkout|Pre-orders|Despatched together)/i.test(estimate)) estimate = '';
    var mainRows = [], detailRows = [];
    if (stock || country !== 'GB') {
      var duration = /\b(?:days?|hours?|after (?:despatch|dispatch))\b/i.test(estimate);
      var actualArrival = !duration && /^Estimated (?:arrival|delivery)\b/i.test(estimate);
      var arrival = estimate.replace(/^Estimated (?:delivery(?: by)?|arrival)\s*/i, '');
      if (String(theme.id) === '187352842618' && actualArrival && (country !== 'GB' || !preorder)) {
        mainRows.push(['Estimated delivery ' + arrival, '', 'arrival', stock && !preorder ? 'dispatch-info' : '']);
      } else {
        mainRows.push([country === 'GB' && preorder && stock ? 'In-stock delivery' : actualArrival || !arrival ? 'Estimated delivery' : 'Delivery time', arrival || (shipping && shipping.status === 'pending' ? 'Checking…' : 'Confirmed at checkout')]);
      }
      if (country === 'GB' && stock && preorder) detailRows.push(['In-stock delivery', arrival || (shipping && shipping.status === 'pending' ? 'Checking…' : 'Confirmed at checkout')]);
    }
    if (preorder && country === 'GB') {
      var groups = [], missing = 0;
      Array.prototype.forEach.call(drawer.querySelectorAll('.NativeUcdCartItem--preOrder'), function (item) {
        var input = item.querySelector('[data-native-ucd-line-quantity]');
        var arrival = contextCurrent && typeof window.dsrcvGetCartPreorderArrival === 'function' ? text(window.dsrcvGetCartPreorderArrival(country, subtotal, rate, input && input.getAttribute('data-line-id'))).replace(/^Estimated (?:arrival|delivery(?: by)?)\s*/i, '') : '';
        if (!arrival) missing++;
        var date = arrival || 'Date unavailable';
        var group = groups.find(function (entry) { return entry.date === date; });
        if (!group) { group = {date: date, items: []}; groups.push(group); }
        group.items.push(itemName(item));
      });
      var dates = groups.filter(function (group) { return group.date !== 'Date unavailable'; }).map(function (group) { return group.date; });
      mainRows.push([stock || groups.length > 1 ? 'Pre-order deliveries' : 'Estimated delivery', missing ? dates.length ? 'Some dates unavailable' : 'Date unavailable' : shortDates(dates) || 'Date unavailable']);
      groups.forEach(function (group) { detailRows.push([group.items.join(', '), group.date]); });
    }
    rows(summary.querySelector('[data-cart-shipment-headline]'), mainRows);
    rows(panel.querySelector('[data-cart-shipment-rows]'), detailRows);
    var notes = [];
    if (preorder) notes.push(country !== 'GB' ? 'Your items ship together once all items are ready.' : stock ? 'In-stock items ship first. Pre-order items ship separately once available.' : 'Pre-order items ship as they become available.');
    var information = summary.querySelector('[data-bf-basket-delivery], [data-cart-delivery-information]');
    if (information) {
      if (!information.classList.contains('CartShipmentSource')) information.classList.add('CartShipmentSource');
      Array.prototype.forEach.call(information.querySelectorAll('p'), function (paragraph) {
        if (paragraph.hasAttribute('data-cart-delivery-estimate')) return;
        var note = text(paragraph.textContent); if (note && notes.indexOf(note) === -1) notes.push(note);
      });
    }
    var noteContainer = panel.querySelector('[data-cart-shipment-notes]'), signature = JSON.stringify(notes);
    if (noteContainer.getAttribute('data-content') !== signature) {
      noteContainer.textContent = '';
      notes.forEach(function (note) { var paragraph = document.createElement('p'); paragraph.textContent = note; noteContainer.appendChild(paragraph); });
      noteContainer.setAttribute('data-content', signature);
    }
    compactBenefits(drawer, summary);
  }
  function schedule() { if (!queued) { queued = true; Promise.resolve().then(render); } }
  document.addEventListener('click', function (event) { if (event.target.closest('[data-cart-shipment-toggle]')) { open = !open; render(); } });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!event.repeat) escapeHandled = false;
    var arrival = event.target.closest('[data-cart-arrival-information]');
    if (arrival && arrival.open) {
      arrival.open = false; arrival.querySelector('summary').focus(); escapeHandled = true;
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    var returns = event.target.closest('[data-cart-returns-disclosure]');
    if (returns && returns.open) {
      returns.open = false; returns.querySelector('summary').focus(); escapeHandled = true;
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (!open || !event.target.closest('[data-cart-shipment-toggle], [data-cart-shipment-panel]')) return;
    open = false; render(); var button = document.querySelector('#sidebar-cart [data-cart-shipment-toggle]'); if (button) button.focus();
    escapeHandled = true; event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  // Prestige closes drawers on keyup; consume the same Escape that closed
  // an inner disclosure, while allowing the next Escape to close the cart.
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' || !escapeHandled) return;
    escapeHandled = false; event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  function start() {
    var drawer = document.getElementById('sidebar-cart'); if (!drawer) return;
    var observer = new MutationObserver(function (records) {
      if (records.some(function (record) {
        var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return node && !node.closest('[data-cart-shipment-headline], [data-cart-shipment-panel], [data-cart-shipment-toggle]');
      })) schedule();
    });
    observer.observe(drawer, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'value', 'data-native-ucd-line-properties', 'data-native-ucd-has-pre-order', 'data-native-ucd-has-non-pre-order']});
    window.addEventListener('pagehide', function () { observer.disconnect(); }, {once: true}); schedule();
  }
  ['dsrcv:delivery-promise:rendered', 'dsrcv:cart-shipping-updated', 'cart:refresh', 'cart:updated', 'country:change', 'currency:change', 'covCurrency:updated'].forEach(function (name) { document.addEventListener(name, schedule); });
  document.addEventListener('change', schedule, true);
  window.dsrcvCartDeliveryDisclosure = {render: schedule};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
}());
